<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
        metaInfo: {
            meta: [
                {name: 'description', content: 'توضیحات سایت'}
            ],
            titleTemplate: '%s - سامانه پارسیان'
        }
    }
</script>
<style>
    html,body{
        overflow-x: hidden;

    }
    body {
        font-family: IRANSans !important;

    }
    .ltr {
        direction: ltr;
    }


    .nav-link {
        padding: .4rem 1rem;
    }
    .list-unstyled {
        padding-left: 0;

    }
</style>



// WEBPACK FOOTER //
// src/App.vue